export default __webpack_public_path__ + "PBSLM-Logo-Open-Area.svg";